/**
 * Promo / sibling / venue-index helpers
 * Extends window.WorkshopBookingWizardHelpers (defer after helpers.js).
 */
(function (global) {
  'use strict';
  var H = global.WorkshopBookingWizardHelpers;
  if (!H) return;

  var extractNumericEventIdForUrl = H.extractNumericEventIdForUrl;
  var extractNumericVenueRefForUrl = H.extractNumericVenueRefForUrl;
  var normalizeTimeLabel = H.normalizeTimeLabel;
  var refsOverlap = H.refsOverlap;
  var slotDateKey = H.slotDateKey;
  var toIsoDateKey = H.toIsoDateKey;

  function parseSiblingPromoData(sectionId) {
    var el = sectionId ? document.getElementById('WorkshopSiblingPromoData-' + sectionId) : null;
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (_) {
      return null;
    }
  }

  function siblingPromoScope(wizardRoot, sectionId) {
    if (wizardRoot) {
      var slotHost = wizardRoot.querySelector('[data-wbw-promo-slot] [data-wbw-sibling-promo-wrap]');
      if (slotHost) {
        var embedded = slotHost.closest('[data-workshop-sibling-promo]');
        return embedded || wizardRoot;
      }
    }
    var sid = sectionId || (wizardRoot && wizardRoot.getAttribute('data-section-id'));
    if (sid) {
      var section = document.getElementById('shopify-section-' + sid);
      if (section && section.querySelector('[data-wbw-sibling-promo-wrap]')) return section;
      var host = document.querySelector(
        '[data-workshop-sibling-promo][data-section-id="' +
          String(sid).replace(/\\/g, '\\\\').replace(/"/g, '\\"') +
          '"]'
      );
      if (host) return host.closest('.shopify-section') || host;
    }
    var near = wizardRoot && wizardRoot.closest('.shopify-section');
    if (near && near.querySelector('[data-wbw-sibling-promo-wrap]')) return near;
    return document;
  }

  function attachSiblingPromoHost(wizardRoot, sectionId) {
    if (!wizardRoot) return;
    var slot = wizardRoot.querySelector('[data-wbw-promo-slot]');
    if (!slot) return;
    var sid = String(sectionId || wizardRoot.getAttribute('data-section-id') || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
    var sel = '[data-workshop-sibling-promo][data-section-id="' + sid + '"]';
    var section = wizardRoot.closest('.shopify-section');
    var slotHost = slot.querySelector(sel);
    if (slotHost) {
      if (section) {
        section.querySelectorAll(sel).forEach(function (host) {
          if (host !== slotHost && !slot.contains(host)) host.remove();
        });
      }
      return;
    }
    var host = (section && section.querySelector(sel)) || document.querySelector(sel);
    if (host && host.parentNode !== slot) slot.appendChild(host);
  }

  function ensureSiblingPromoDom(wizardRoot, sectionId) {
    attachSiblingPromoHost(wizardRoot, sectionId);
    var slot = wizardRoot && wizardRoot.querySelector('[data-wbw-promo-slot]');
    if (!slot) return;
    var hosts = slot.querySelectorAll('[data-workshop-sibling-promo]');
    for (var hi = 1; hi < hosts.length; hi++) hosts[hi].remove();
    if (slot.querySelector('[data-wbw-sibling-promo-wrap]')) return;
    var host = document.createElement('div');
    host.className = 'wbw-sibling-promo-host';
    host.setAttribute('data-workshop-sibling-promo', '');
    host.setAttribute('data-section-id', String(sectionId || wizardRoot.getAttribute('data-section-id') || ''));
    host.innerHTML =
      '<div class="wbw-sibling-promo-wrap" data-wbw-sibling-promo-wrap hidden aria-hidden="true">' +
      '<div class="wbw-sibling-promo-list" data-wbw-sibling-promo-list></div></div>';
    slot.appendChild(host);
  }

  function siblingPromoHosts(wizardRoot, sectionId) {
    var sid = String(sectionId || (wizardRoot && wizardRoot.getAttribute('data-section-id')) || '')
      .replace(/\\/g, '\\\\')
      .replace(/"/g, '\\"');
    if (!sid) return [];
    var sel = '[data-workshop-sibling-promo][data-section-id="' + sid + '"]';
    var section = wizardRoot && wizardRoot.closest('.shopify-section');
    var hosts = section ? section.querySelectorAll(sel) : document.querySelectorAll(sel);
    return Array.prototype.slice.call(hosts || []);
  }

  var WB_HANDLE_ALIAS_GROUPS = [
    ['mosaic-lamp-workshop', 'mosaic-workshop', 'mosaic-classes', 'mosaic-classess'],
    ['ceramic-painting-workshop', 'ceramic-painting-classes', 'ceramic-painting-classess'],
    ['flower-decorating', 'flower-decoration'],
    ['resin-art-workshop', 'resin-art', 'resin-workshop'],
  ];

  function handlesMatchForPromo(a, b) {
    a = String(a || '')
      .trim()
      .toLowerCase();
    b = String(b || '')
      .trim()
      .toLowerCase();
    if (!a || !b) return false;
    if (a === b) return true;
    for (var gi = 0; gi < WB_HANDLE_ALIAS_GROUPS.length; gi++) {
      var group = WB_HANDLE_ALIAS_GROUPS[gi];
      if (group.indexOf(a) >= 0 && group.indexOf(b) >= 0) return true;
    }
    return false;
  }

  function canonicalPromoHandle(h) {
    h = String(h || '')
      .trim()
      .toLowerCase();
    if (!h) return '';
    for (var gi = 0; gi < WB_HANDLE_ALIAS_GROUPS.length; gi++) {
      var group = WB_HANDLE_ALIAS_GROUPS[gi];
      if (group.indexOf(h) >= 0) return group[0];
    }
    return h;
  }

  function buildPromoVenueContext(venue, venueCard, slot) {
    var raw = slot && slot._raw;
    return {
      venue_ref_id: String((venue && venue.venue_ref_id) || (raw && raw.venue_ref_id) || '').trim(),
      venue_handle: String(
        (venue && (venue.venue_handle || venue.handle)) || (raw && raw.venue_handle) || ''
      )
        .trim()
        .toLowerCase(),
      venue_name: String(
        (venue && (venue.venue_name || venue.name)) || (raw && raw.venue_name) || ''
      ).trim(),
      city: String(
        (venue && (venue.city || venue.city_name)) || (raw && (raw.city || raw.city_name)) || ''
      ).trim(),
      state: String((venue && (venue.state || venue.state_code)) || (raw && (raw.state || raw.state_code)) || '')
        .trim()
        .toLowerCase(),
      cardLabel:
        venueCard && venueCard.getAttribute
          ? String(venueCard.getAttribute('data-wbw-city-label') || '').trim()
          : '',
    };
  }

  function venueRowMatchesContextScore(row, ctx) {
    if (!row || !ctx) return -1;
    if (
      refsOverlap(
        venueRefAliasKeys(ctx.venue_ref_id),
        venueRefAliasKeys(row.venue_ref_id)
      )
    ) {
      return 5;
    }
    var rowHandle = String(row.venue_handle || '')
      .trim()
      .toLowerCase();
    if (ctx.venue_handle && rowHandle && ctx.venue_handle === rowHandle) return 5;
    var labels = [ctx.venue_name, ctx.cardLabel];
    for (var li = 0; li < labels.length; li++) {
      if (venueNamesLooselyMatch(labels[li], row.venue_name)) return 4;
    }
    var ctxCity = venueNameLookupKey(ctx.city);
    var rowCity = venueNameLookupKey(row.city || '');
    if (ctxCity && rowCity && ctxCity === rowCity) return 2;
    if (ctxCity && ctxCity.length >= 4 && venueNamesLooselyMatch(row.venue_name, ctxCity)) return 1;
    return -1;
  }

  function resolvePromoDeepLinkFromIndex(targetHandle, currentHandle, venue, venueCard, slot, indexRows) {
    targetHandle = String(targetHandle || '')
      .trim()
      .toLowerCase();
    currentHandle = String(currentHandle || '')
      .trim()
      .toLowerCase();
    if (!targetHandle || !slot) return { eventId: '', venueHandle: '' };

    var ctx = buildPromoVenueContext(venue, venueCard, slot);
    var curDate = slotDateKey(slot);
    var curTime = normalizeTimeLabel(slot.time_label);
    indexRows = indexRows || [];
    var best = null;
    var bestScore = -1;

    function considerRow(row, score) {
      var eid = extractNumericEventIdForUrl(row.event_id || row.id || '');
      if (!eid || score <= bestScore) return;
      bestScore = score;
      best = row;
    }

    indexRows.forEach(function (row) {
      if (!handlesMatchForPromo(row.product_handle, targetHandle)) return;
      var dk = toIsoDateKey(row.date_key);
      if (curDate && dk && dk !== curDate) return;
      var rowTime = normalizeTimeLabel(row.time_label);
      var timeOk = !curTime || !rowTime || rowTime === curTime;
      var venueScore = venueRowMatchesContextScore(row, ctx);
      if (venueScore < 0) return;
      considerRow(row, venueScore + (timeOk ? 20 : 0));
    });

    if (!best && currentHandle) {
      var anchorNames = Object.create(null);
      indexRows.forEach(function (row) {
        if (!handlesMatchForPromo(row.product_handle, currentHandle)) return;
        var dk = toIsoDateKey(row.date_key);
        if (curDate && dk && dk !== curDate) return;
        var rowTime = normalizeTimeLabel(row.time_label);
        if (curTime && rowTime && rowTime !== curTime) return;
        var nk = venueNameLookupKey(row.venue_name);
        if (nk) anchorNames[nk] = true;
      });
      if (ctx.venue_name) anchorNames[venueNameLookupKey(ctx.venue_name)] = true;
      if (ctx.cardLabel) anchorNames[venueNameLookupKey(ctx.cardLabel)] = true;
      if (ctx.city) anchorNames[venueNameLookupKey(ctx.city)] = true;

      indexRows.forEach(function (row) {
        if (!handlesMatchForPromo(row.product_handle, targetHandle)) return;
        var dk = toIsoDateKey(row.date_key);
        if (curDate && dk && dk !== curDate) return;
        var rowTime = normalizeTimeLabel(row.time_label);
        var timeOk = !curTime || !rowTime || rowTime === curTime;
        var rowNk = venueNameLookupKey(row.venue_name);
        var nameHit = !!(rowNk && anchorNames[rowNk]);
        if (!nameHit && rowNk) {
          Object.keys(anchorNames).forEach(function (ak) {
            if (!nameHit && venueNamesLooselyMatch(ak, rowNk)) nameHit = true;
          });
        }
        var cityHit = !!(ctx.city && venueNameLookupKey(row.city || '') === venueNameLookupKey(ctx.city));
        if (!nameHit && !cityHit) return;
        considerRow(row, (nameHit ? 15 : 10) + (timeOk ? 20 : 0) + (cityHit ? 5 : 0));
      });
    }

    if (!best) {
      indexRows.forEach(function (row) {
        if (!handlesMatchForPromo(row.product_handle, targetHandle)) return;
        var dk = toIsoDateKey(row.date_key);
        if (curDate && dk && dk !== curDate) return;
        var venueScore = venueRowMatchesContextScore(row, ctx);
        if (venueScore < 1) return;
        considerRow(row, venueScore);
      });
    }

    if (!best) {
      indexRows.forEach(function (row) {
        if (!handlesMatchForPromo(row.product_handle, targetHandle)) return;
        var dk = toIsoDateKey(row.date_key);
        if (curDate && dk && dk !== curDate) return;
        var rowTime = normalizeTimeLabel(row.time_label);
        if (curTime && rowTime && rowTime !== curTime) return;
        considerRow(row, 2);
      });
    }

    if (!best) return { eventId: '', venueHandle: '' };
    return {
      eventId: extractNumericEventIdForUrl(best.event_id || best.id || ''),
      venueHandle: extractNumericVenueRefForUrl(best.venue_ref_id) || '',
    };
  }

  var WB_SIBLING_HANDLE_FALLBACKS = {
    'mosaic-lamp-workshop': ['ceramic-painting-workshop', 'ceramic-painting-classes', 'ceramic-painting-classess'],
    'mosaic-workshop': ['ceramic-painting-workshop', 'ceramic-painting-classes', 'ceramic-painting-classess'],
    'mosaic-classess': ['ceramic-painting-classess', 'ceramic-painting-classes'],
    'mosaic-classes': ['ceramic-painting-classess', 'ceramic-painting-classes'],
    'ceramic-painting-classess': ['mosaic-lamp-workshop', 'mosaic-classess', 'mosaic-classes', 'mosaic-workshop'],
    'ceramic-painting-classes': ['mosaic-lamp-workshop', 'mosaic-classess', 'mosaic-classes', 'mosaic-workshop'],
    'ceramic-painting-workshop': ['mosaic-lamp-workshop', 'mosaic-workshop', 'mosaic-classes', 'mosaic-classess'],
  };

  var WB_SIBLING_LABELS = {
    'mosaic-lamp-workshop': 'Mosaic Lamp Workshop',
    'mosaic-classess': 'Mosaic Lamp Classes',
    'mosaic-classes': 'Mosaic Lamp Classes',
    'mosaic-workshop': 'Mosaic Workshop',
    'ceramic-painting-classess': 'Ceramic Painting Classes',
    'ceramic-painting-classes': 'Ceramic Painting Classes',
    'ceramic-painting-workshop': 'Ceramic Painting Workshop',
    'flower-decorating': 'Flower Decorating',
    'flower-decoration': 'Flower Decorating',
    'resin-art-workshop': 'Resin Art Workshop',
    'resin-art': 'Resin Art Workshop',
    'resin-workshop': 'Resin Art Workshop',
  };

  function parseVenueWaitlistCatalog(bookingRoot) {
    if (!bookingRoot) return [];
    var el = bookingRoot.querySelector('script[type="application/json"][data-wb-venues-waitlist-catalog]');
    if (!el) return [];
    try {
      var parsed = JSON.parse(el.textContent || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function findCatalogVenueByToken(catalog, venueToken) {
    if (!catalog || !catalog.length || !venueToken) return null;
    var tokenNum = extractNumericVenueRefForUrl(venueToken);
    var tokenLower = String(venueToken).trim().toLowerCase();
    for (var i = 0; i < catalog.length; i++) {
      var row = catalog[i];
      if (!row) continue;
      if (tokenNum && extractNumericVenueRefForUrl(row.venue_ref_id) === tokenNum) return row;
      var venueHandle = String(row.venue_handle || '').trim().toLowerCase();
      var venueName = String(row.venue_name || '').trim().toLowerCase();
      if (tokenLower && (venueHandle === tokenLower || venueName === tokenLower)) return row;
      if (tokenLower && venueName && venueNamesLooselyMatch(venueName, tokenLower)) return row;
    }
    return null;
  }

  function parseVenueWorkshopIndex(sectionId) {
    var rows = [];
    var seen = Object.create(null);
    function absorb(el) {
      if (!el) return;
      try {
        var parsed = JSON.parse(el.textContent || '[]');
        if (!Array.isArray(parsed)) return;
        parsed.forEach(function (row) {
          if (!row) return;
          var eid = extractNumericEventIdForUrl(row.event_id || row.id || '');
          var ph = String(row.product_handle || '')
            .trim()
            .toLowerCase();
          var key = (eid || 'x') + '|' + (ph || 'x') + '|' + toIsoDateKey(row.date_key);
          if (seen[key]) return;
          seen[key] = true;
          rows.push(row);
        });
      } catch (_) {}
    }
    if (sectionId) absorb(document.getElementById('WorkshopVenueWorkshopIndex-' + sectionId));
    if (typeof document !== 'undefined') {
      document.querySelectorAll('script[id^="WorkshopVenueWorkshopIndex-"]').forEach(absorb);
    }
    return rows;
  }

  function findIndexRowByEventId(indexRows, eventId) {
    var num = extractNumericEventIdForUrl(eventId);
    if (!num || !indexRows || !indexRows.length) return null;
    for (var i = 0; i < indexRows.length; i++) {
      var row = indexRows[i];
      if (!row) continue;
      if (extractNumericEventIdForUrl(row.event_id || row.id || '') === num) return row;
    }
    return null;
  }

  function promoEventIdMatchesVenueContext(eventId, venue, venueCard, slot, indexRows) {
    var row = findIndexRowByEventId(indexRows, eventId);
    if (!row) return false;
    var ctx = buildPromoVenueContext(venue, venueCard, slot);
    return venueRowMatchesContextScore(row, ctx) >= 4;
  }

  function resolveVenueAnchoredPromoEventId(
    targetHandle,
    currentHandle,
    venue,
    venueCard,
    slot,
    indexRows,
    fallbackEventId
  ) {
    var eventId = '';
    if (slot) {
      eventId = resolveSiblingEventIdFromSessionAnchor(
        targetHandle,
        slot,
        venue,
        venueCard,
        indexRows
      );
    }
    if (!eventId) {
      var idx = resolvePromoDeepLinkFromIndex(
        targetHandle,
        currentHandle,
        venue,
        venueCard,
        slot,
        indexRows
      );
      eventId = idx.eventId || '';
    }
    if (
      !eventId &&
      fallbackEventId &&
      promoEventIdMatchesVenueContext(fallbackEventId, venue, venueCard, slot, indexRows)
    ) {
      eventId = extractNumericEventIdForUrl(fallbackEventId);
    }
    return eventId || '';
  }

  function resolveEventIdForProductAtVenue(productHandle, venue, venueCard, hintEventId, indexRows) {
    productHandle = String(productHandle || '')
      .trim()
      .toLowerCase();
    if (!productHandle || !venue) return '';
    var ctx = buildPromoVenueContext(venue, venueCard, null);
    var hintDate = '';
    var hintTime = '';
    if (hintEventId) {
      var hintRow = findIndexRowByEventId(indexRows, hintEventId);
      if (hintRow) {
        hintDate = toIsoDateKey(hintRow.date_key);
        hintTime = normalizeTimeLabel(hintRow.time_label);
      }
    }
    var best = null;
    var bestScore = -1;
    indexRows = indexRows || [];
    indexRows.forEach(function (row) {
      if (!row || !handlesMatchForPromo(row.product_handle, productHandle)) return;
      var venueScore = venueRowMatchesContextScore(row, ctx);
      if (venueScore < 4) return;
      var score = venueScore;
      var dk = toIsoDateKey(row.date_key);
      var rowTime = normalizeTimeLabel(row.time_label);
      if (hintDate && dk === hintDate) score += 20;
      if (hintTime && rowTime === hintTime) score += 20;
      if (score > bestScore) {
        bestScore = score;
        best = row;
      }
    });
    return best ? extractNumericEventIdForUrl(best.event_id || best.id || '') : '';
  }

  function slotListContainsEventId(slots, eventId) {
    var urlNum = extractNumericEventIdForUrl(eventId);
    if (!urlNum || !Array.isArray(slots)) return false;
    for (var i = 0; i < slots.length; i++) {
      var s = slots[i];
      var raw = s && s._raw;
      var num = extractNumericEventIdForUrl(
        (raw && (raw.id || raw.event_metaobject_gid || raw.gid)) || (s && s.gid) || ''
      );
      if (num && num === urlNum) return true;
    }
    return false;
  }

  /** Match sibling event_id at same venue/session using the currently selected slot as anchor. */
  function resolveSiblingEventIdFromSessionAnchor(targetHandle, slot, venue, venueCard, indexRows) {
    targetHandle = String(targetHandle || '')
      .trim()
      .toLowerCase();
    if (!targetHandle || !slot || !indexRows || !indexRows.length) return '';

    var raw = slot._raw || {};
    var anchorRow = findIndexRowByEventId(
      indexRows,
      raw.id || raw.event_metaobject_gid || raw.gid || slot.gid || ''
    );
    var ctx = buildPromoVenueContext(venue, venueCard, slot);
    var sessionDate = slotDateKey(slot);
    var sessionTime = normalizeTimeLabel(slot.time_label);
    var sessionVenueKeys = venueRefAliasKeys(
      (anchorRow && anchorRow.venue_ref_id) || ctx.venue_ref_id || raw.venue_ref_id || ''
    );

    if (anchorRow) {
      if (!sessionDate) sessionDate = toIsoDateKey(anchorRow.date_key);
      if (!sessionTime) sessionTime = normalizeTimeLabel(anchorRow.time_label);
      if (!sessionVenueKeys.length) sessionVenueKeys = venueRefAliasKeys(anchorRow.venue_ref_id);
    }

    if (!sessionDate || !sessionTime) return '';

    var candidates = [];
    indexRows.forEach(function (row) {
      if (!row || !handlesMatchForPromo(row.product_handle, targetHandle)) return;
      var dk = toIsoDateKey(row.date_key);
      if (dk !== sessionDate) return;
      var rowTime = normalizeTimeLabel(row.time_label);
      if (!rowTime || rowTime !== sessionTime) return;
      var venueScore = sessionVenueKeys.length
        ? refsOverlap(sessionVenueKeys, venueRefAliasKeys(row.venue_ref_id))
          ? 5
          : venueRowMatchesContextScore(row, ctx) >= 1
            ? 2
            : -1
        : venueRowMatchesContextScore(row, ctx);
      if (venueScore < 0) return;
      candidates.push({ row: row, score: venueScore });
    });

    if (!candidates.length) return '';

    candidates.sort(function (a, b) {
      return b.score - a.score;
    });

    return extractNumericEventIdForUrl(candidates[0].row.event_id || candidates[0].row.id || '');
  }

  function venueRefAliasKeys(id) {
    var keys = [];
    var seen = Object.create(null);
    function add(k) {
      k = String(k || '').trim();
      if (!k || seen[k]) return;
      seen[k] = true;
      keys.push(k);
    }
    var raw = String(id == null ? '' : id).trim();
    if (!raw) return keys;
    add(raw);
    add(normalizeVenueRefId(raw));
    var m = raw.match(/(\d+)\s*$/);
    if (m) {
      add(m[1]);
      add('gid://shopify/Metaobject/' + m[1]);
    }
    if (raw.indexOf('v_') === 0) add(raw);
    return keys;
  }

  function venueNameLookupKey(name) {
    return String(name || '')
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');
  }

  function buildVenueWorkshopMaps(rows) {
    var byRef = Object.create(null);
    var byName = Object.create(null);
    (rows || []).forEach(function (row) {
      if (!row) return;
      var h = String(row.product_handle || '')
        .trim()
        .toLowerCase();
      if (!h) return;
      venueRefAliasKeys(row.venue_ref_id).forEach(function (vid) {
        if (!byRef[vid]) byRef[vid] = Object.create(null);
        byRef[vid][h] = true;
      });
      var nameKey = venueNameLookupKey(row.venue_name);
      if (nameKey) {
        if (!byName[nameKey]) byName[nameKey] = Object.create(null);
        byName[nameKey][h] = true;
      }
    });
    return { byRef: byRef, byName: byName };
  }

  function normalizeVenueRefId(id) {
    var s = String(id == null ? '' : id).trim();
    if (!s) return '';
    if (s.indexOf('gid://') === 0) return s;
    var m = s.match(/Metaobject\/(\d+)$/i);
    if (m) return 'gid://shopify/Metaobject/' + m[1];
    if (/^\d+$/.test(s)) return 'gid://shopify/Metaobject/' + s;
    return s;
  }

  function ensureSiblingWorkshops(list, productHandle) {
    var out = Array.isArray(list) ? list.slice() : [];
    if (out.length) return out;
    var current = String(productHandle || '')
      .trim()
      .toLowerCase();
    var fallbacks = WB_SIBLING_HANDLE_FALLBACKS[current] || [];
    for (var i = 0; i < fallbacks.length; i++) {
      var h = String(fallbacks[i] || '').trim();
      if (!h || h === current) continue;
      out.push({
        handle: h,
        title: WB_SIBLING_LABELS[h] || h,
        label: WB_SIBLING_LABELS[h] || h,
        url: '/products/' + encodeURIComponent(h),
        image: null,
      });
      break;
    }
    return out;
  }

  function collectAlsoAvailableHandles(source, out) {
    if (!source) return;
    var aa = source.also_available_products;
    if (!Array.isArray(aa)) return;
    aa.forEach(function (p) {
      var h = String((p && (p.handle || p.product_handle || p.productHandle)) || '')
        .trim()
        .toLowerCase();
      if (h) out[h] = true;
    });
  }

  function venueNamesLooselyMatch(a, b) {
    a = venueNameLookupKey(a);
    b = venueNameLookupKey(b);
    if (!a || !b) return false;
    if (a === b) return true;
    if (a.length >= 4 && (a.indexOf(b) >= 0 || b.indexOf(a) >= 0)) return true;
    return false;
  }

  function venueMatchesIndexRow(venue, row, venueCard) {
    if (!venue || !row) return false;
    if (
      refsOverlap(
        venueRefAliasKeys(venue.venue_ref_id),
        venueRefAliasKeys(row.venue_ref_id)
      )
    ) {
      return true;
    }
    var venueHandle = String(venue.venue_handle || venue.handle || '').trim().toLowerCase();
    var rowHandle = String(row.venue_handle || '').trim().toLowerCase();
    if (venueHandle && rowHandle && venueHandle === rowHandle) return true;
    var cardLabel =
      venueCard && venueCard.getAttribute
        ? String(venueCard.getAttribute('data-wbw-city-label') || '').trim()
        : '';
    var venueNames = [venue.venue_name, venue.name, venue.city_name, cardLabel];
    for (var ni = 0; ni < venueNames.length; ni++) {
      if (venueNamesLooselyMatch(venueNames[ni], row.venue_name)) return true;
    }
    var cityKey = venueNameLookupKey(venue.city || venue.city_name || '');
    if (cityKey && cityKey.length >= 4 && venueNamesLooselyMatch(row.venue_name, cityKey)) return true;
    return false;
  }
  H.WB_HANDLE_ALIAS_GROUPS = WB_HANDLE_ALIAS_GROUPS;
  H.WB_SIBLING_HANDLE_FALLBACKS = WB_SIBLING_HANDLE_FALLBACKS;
  H.WB_SIBLING_LABELS = WB_SIBLING_LABELS;
  H.attachSiblingPromoHost = attachSiblingPromoHost;
  H.buildPromoVenueContext = buildPromoVenueContext;
  H.buildVenueWorkshopMaps = buildVenueWorkshopMaps;
  H.canonicalPromoHandle = canonicalPromoHandle;
  H.collectAlsoAvailableHandles = collectAlsoAvailableHandles;
  H.ensureSiblingPromoDom = ensureSiblingPromoDom;
  H.ensureSiblingWorkshops = ensureSiblingWorkshops;
  H.findCatalogVenueByToken = findCatalogVenueByToken;
  H.findIndexRowByEventId = findIndexRowByEventId;
  H.handlesMatchForPromo = handlesMatchForPromo;
  H.normalizeVenueRefId = normalizeVenueRefId;
  H.parseSiblingPromoData = parseSiblingPromoData;
  H.parseVenueWaitlistCatalog = parseVenueWaitlistCatalog;
  H.parseVenueWorkshopIndex = parseVenueWorkshopIndex;
  H.promoEventIdMatchesVenueContext = promoEventIdMatchesVenueContext;
  H.resolveEventIdForProductAtVenue = resolveEventIdForProductAtVenue;
  H.resolvePromoDeepLinkFromIndex = resolvePromoDeepLinkFromIndex;
  H.resolveSiblingEventIdFromSessionAnchor = resolveSiblingEventIdFromSessionAnchor;
  H.resolveVenueAnchoredPromoEventId = resolveVenueAnchoredPromoEventId;
  H.siblingPromoHosts = siblingPromoHosts;
  H.siblingPromoScope = siblingPromoScope;
  H.slotListContainsEventId = slotListContainsEventId;
  H.venueMatchesIndexRow = venueMatchesIndexRow;
  H.venueNameLookupKey = venueNameLookupKey;
  H.venueNamesLooselyMatch = venueNamesLooselyMatch;
  H.venueRefAliasKeys = venueRefAliasKeys;
  H.venueRowMatchesContextScore = venueRowMatchesContextScore;
})(typeof window !== "undefined" ? window : this);
